// extracted by mini-css-extract-plugin
export var cookiesSection = "d7_JQ";
export var cookiesSection__btn = "d7_JT";
export var cookiesSection__link = "d7_JS";
export var cookiesSection__text = "d7_JR";
export var cookiesSection__wrapper = "d7_JP";